import { Grid } from "@material-ui/core";
import React from "react";

export const Row = ({ ...p }) => <Grid container {...p} spacing={2} />;
export const Column = ({ lg, md, sm, xs, ...p }) => (
  <Grid {...{ lg, md, sm, xs }} item {...p} />
);
